var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgParagraphimageleft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 40,
    viewBox: "0 0 24 24",
    width: 40,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0V0z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-180 12,12.318471908569336) ",
    id: "svg_2",
    d: "m3,15.31847l8,0l0,-2l-8,0l0,2zm0,4l8,0l0,-2l-8,0l0,2zm0,-8l8,0l0,-2l-8,0l0,2zm0,-6l0,2l8,0l0,-2l-8,0zm10,0l8,0l0,14l-8,0l0,-14z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParagraphimageleft);
export default __webpack_public_path__ + "static/media/paragraphimageleft.553def3bf8f1ff1e440be86c4ce48de2.svg";
export { ForwardRef as ReactComponent };